import { createContext } from "react";


const QuizDataContext = createContext();

export default QuizDataContext;